import React from "react";
import { separate } from "../../Functions/NumberSeprator";
import FactorList from "../FactorList/FactorList";
import factor from "./Factor.module.css";
import { useHistory } from "react-router-dom";
import { splitJalaliDateTime } from "../../Functions/convertDateToJalali";
import {
  Receipt,
  PencilSquare,
  ChatLeftText,
  CashStack,
  InfoCircle,
} from "react-bootstrap-icons";

const Factor = ({ data, orderID }) => {
  const history = useHistory();

  // If data is still loading
  if (!data || !Array.isArray(data.products)) {
    return (
      <div className={factor.loadingContainer}>
        <div className={factor.spinner}></div>
        <p className={factor.loadingText}>در حال دریافت اطلاعات فاکتور...</p>
      </div>
    );
  }

  // Calculate total price based on active prices, active counts, and availability
  let totalPrice = 0;
  let totalFee = 0;
  let hasAnyChanges = false;
  let hasUnavailableItems = false;

  data.products.forEach((element) => {
    const isUnavailable =
      element.availability === "0" ||
      element.availability === 0 ||
      element.availability === false;

    if (isUnavailable) {
      hasUnavailableItems = true;
      hasAnyChanges = true;
    }

    // Check count change
    const isCountChanged =
      element.new_count !== undefined &&
      element.new_count !== null &&
      String(element.new_count).trim() !== "" &&
      String(element.new_count) !== String(element.count);

    // Check price change
    const cleanPrice = String(element.price || "0").replace(/,/g, "");
    const cleanNewPrice = String(element.new_price || "").replace(/,/g, "");
    const isPriceChanged =
      cleanNewPrice !== "" &&
      cleanNewPrice !== "0" &&
      parseInt(cleanNewPrice, 10) !== parseInt(cleanPrice, 10);

    // Check replacement
    const isReplaced =
      element.p_product_id !== undefined &&
      element.p_product_id !== null &&
      String(element.p_product_id) !== "0" &&
      String(element.p_product_id) !== "";

    if (isCountChanged || isPriceChanged || isReplaced) {
      hasAnyChanges = true;
    }

    const activeCount = isCountChanged
      ? Number(element.new_count)
      : Number(element.count || 1);

    const activePrice = isPriceChanged
      ? Number(cleanNewPrice)
      : Number(cleanPrice || 0);

    const fee = Number(element.product_fee || 0);

    if (!isUnavailable) {
      totalPrice += activePrice * activeCount;
      totalFee += fee;
    }
  });

  const orderDescription = data.decription || data.description;

  return (
    <div className={factor.factorHolder}>
      {/* Header */}
      <div className={factor.header}>
        <div className={factor.titleWrapper}>
          <Receipt className={factor.titleIcon} />
          <h2 className={factor.title}>جزئیات فاکتور سفارش</h2>
        </div>
        <div className={factor.headerBadges}>
          {data.date && (
            <span className={factor.dateBadge}>
              {splitJalaliDateTime(data.date).full}
            </span>
          )}
          {orderID && (
            <span className={factor.orderIdBadge}>کد سفارش: #{orderID}</span>
          )}
        </div>
      </div>

      {/* Notice if factor has modified/replaced/unavailable items */}
      {hasAnyChanges && (
        <div className={factor.changeAlert}>
          <InfoCircle className={factor.alertIcon} />
          <span>
            این فاکتور شامل تغییرات (قیمت، تعداد، کالای جایگزین یا ناموجودی)
            توسط تأمین‌کننده است.
          </span>
        </div>
      )}

      {/* Product List */}
      <ul className={factor.factorList}>
        {data.products.map((item, index) => (
          <FactorList key={item.id || index} product={item} />
        ))}
      </ul>

      {/* Customer Description Note */}
      {orderDescription && (
        <div className={factor.descCard}>
          <div className={factor.descHeader}>
            <ChatLeftText />
            <span>توضیحات سفارش:</span>
          </div>
          <p className={factor.descText}>{orderDescription}</p>
        </div>
      )}

      {/* Financial Summary */}
      <div className={factor.summaryBox}>
        {totalFee > 0 && (
          <div className={factor.summaryRow}>
            <span className={factor.summaryLabel}>مجموع کارمزد اقلام:</span>
            <span className={factor.feeAmount}>
              {separate(totalFee)} تومان
            </span>
          </div>
        )}

        <div className={`${factor.summaryRow} ${factor.totalRow}`}>
          <div className={factor.totalTitleGroup}>
            <CashStack className={factor.totalIcon} />
            <span className={factor.totalLabel}>مبلغ کل قابل پرداخت:</span>
          </div>
          <div className={factor.totalPriceGroup}>
            <span className={factor.price}>{separate(totalPrice)}</span>
            <span className={factor.toman}>تومان</span>
          </div>
        </div>

        {hasUnavailableItems && (
          <p className={factor.unavailableNotice}>
            * هزینه کالاهای ناموجود از مبلغ کل کسر شده است.
          </p>
        )}
      </div>

      {/* Supermarket Edit Factor Button */}
      {orderID && (
        <div className={factor.editBtnHolder}>
          <button
            type="button"
            className={factor.editFactorBtn}
            onClick={() => history.push("/changefactor", orderID)}
          >
            <PencilSquare />
            <span>ویرایش فاکتور</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Factor;
